import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { RouteError } from "../../../shared/components/RouteError";
import { RoutePending } from "../../../shared/components/RoutePending";
import { listSearch } from "../../../shared/utils/pagination-search";

const searchSchema = listSearch.extend({
  // Inventory view — locks registered with no bike (BEL-583 `?unassociated=true`).
  unassociated: z.boolean().optional(),
});

/**
 * @purpose Manage IoT devices (locks) and their bike association
 * @primary Devices table
 * @persona danilo-tech
 */
export const Route = createFileRoute("/app/admin/devices/")({
  validateSearch: searchSchema,
  errorComponent: ({ error }) => <RouteError error={error} />,
  pendingComponent: RoutePending,
});
